import { escapeHtml, escapeHtmlBr, extractionrAreaCodeData } from '../utilities'

export default class About {
  constructor() {
    this.el = document.querySelector('.js-about')

    if (!this.el) {
      return
    }

    this.createAbout()
    this.attachEventTrack()
  }

  createAbout() {
    const aboutData = extractionrAreaCodeData(
      '10',
      window.LIVESTATION.MAINCONTENT
    )[0]

    if (!aboutData) {
      return
    }
    if (aboutData.show == '0') {
      return
    }

    const aboutHtml = `
      <div class="modalOpen_button">
        <a class="js-lsModalOpen lsModalOpen_link js-trackEvent" data-label="about_modal_open">
          <img class="modalOpen_button_img" src="/jp/ja/contents/live-commerce/img/notice_icon_modalOpen.png" alt="${escapeHtmlBr(aboutData.store_name)}">
        </a>
      </div>
      <div class="ls-modalParent js-lsModalWrap">
        <div class="ls-modalParent_contents">
          <div class="ls-modalParent_contentsInner js-modalParent_contentsInner">
            <header class="ls-modalChild_header fr-sp-py-s fr-sp-px-1g fr-pc-py-s fr-pc-px-m">
              <h3 class="fr-heading -h3 fr-sp-mr-1g fr-pc-mr-m">${escapeHtmlBr(aboutData.store_name)}</h3>
              <button class="ls-modalChild_headerClose js-lsModalClose js-trackEvent" data-label="#" data-track-event-number="90"><span>CLOSE</span></button>
            </header>
            <div class="ls-modalChild_container">
              <div class="fr-sp-px-1g fr-sp-py-l fr-pc-py-l fr-pc-px-m">
                <p class="fr-sp-mt-m fr-pc-mt-l">${escapeHtmlBr(aboutData.remarks)}</p>
                <div class="ls-textLink fr-sp-pt-m fr-pc-pt-s">
                  <a class="ls-textLink_item js-trackEvent" href="${escapeHtml(aboutData.store_url.pc)}" data-category="live-commerce_Click" data-label="faq" target="_blank" rel="noreferrer">
                    ${escapeHtmlBr(aboutData.free)}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ls-modalParent_overlay js-lsModalClose"></div>
      </div>
    `

    this.el.innerHTML = aboutHtml
  }

  async attachEventTrack() {
    try {
      const items = this.el.querySelectorAll(
        '.js-trackEvent'
      )

      if (!items.length) {
        return
      }

      const { attachEventTrack } = await import(
        /* webpackChunkName: "track" */
        '../modules/trackEvent/track'
      )

      attachEventTrack(items)
    } catch (error) {
      console.log(error)
    }
  }
}
